import {defineStore} from 'pinia'

export const useCookieNoticeStore = defineStore('CookieNoticeStore', {
    persist: true,
    state: () => {
        return {
            isVisible: true
        }
    },

    actions: {
        hide () {
            this.isVisible = false
        }
    }
})
